import { IBlogInfo } from '../graphql/modules/blog'

/**
 * @description Contentful's Preview API returns draft entries with their required
 * fields still empty, so a draft blog can reach us without the text, image or link
 * that a blog card destructures. Any list that renders blog cards must drop those
 * entries first. Published entries always have these fields, so filtering is a
 * no-op outside of live preview.
 * @param {IBlogInfo} blog
 * @returns {boolean}
 */
export const isRenderableBlogCard = (blog?: IBlogInfo | null): boolean =>
  Boolean(blog && blog.title && blog.link?.link && blog.text && blog.image?.alternateText && blog.image?.image)

/**
 * @description Keeps only the blogs that can be rendered as a card. Also tolerates a
 * missing list, which the Preview API can return for an unset reference field.
 * @param {IBlogInfo[]} blogs
 * @returns {IBlogInfo[]}
 */
export const filterRenderableBlogCards = <T extends IBlogInfo>(blogs?: T[] | null): T[] =>
  (blogs ?? []).filter(isRenderableBlogCard)
